// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 790) return "static/chunks/790-41a5a85456249860.js";
	if (chunkId === 526) return "static/chunks/526-aa5b08ee4d408aa4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"280":"986358ae56b542f8","585":"6d076eb40e039beb","628":"fe68eb49eb0263f3","733":"b2cc1c369492c1a4"}[chunkId] + ".js";
};